import {
    getStyleguideSectionById,
    getStyleguideSections,
} from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideSelectors";
import StyleguideState from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideState";
import { StyleguideSectionModel } from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";
import findIndex from "lodash/findIndex";

export interface SetIsStyleguideSectionOpenParameter extends Required<StyleguideSectionModel> {}

export interface SetIsStyleguideSectionOpenHandlerProps extends StyleguideState {}

type HandlerType = Handler<SetIsStyleguideSectionOpenParameter, SetIsStyleguideSectionOpenHandlerProps>;

export const PopulateStyleguideSections: HandlerType = props => {
    const state = props.getState();
    const section = getStyleguideSectionById(props.getState(), props.parameter.id);
    let sections = getStyleguideSections(state);

    if (sections) {
        sections = [...sections];
        const sectionIndex = findIndex(sections, x => x.id === section?.id);
        sections.splice(sectionIndex, 1, props.parameter);
    }

    props.sections = sections;
};

export const DispatchSetIsStyleguideSectionOpen: HandlerType = props => {
    props.dispatch({
        type: "Toolkit/Components/Styleguide/SetIsStyleguideSectionOpen",
        sections: props.sections,
    });
};

export const chain = [PopulateStyleguideSections, DispatchSetIsStyleguideSectionOpen];

const setIsStyleguideSectionOpen = createHandlerChainRunner(chain, "SetIsStyleguideSectionOpen");

export default setIsStyleguideSectionOpen;
